import {ReactReader} from "react-reader";
import {useState} from "react";
import {Card} from "@radix-ui/themes";

interface CustomReaderProps {
    s3BookId: string;
    title: string;
}

const CustomReader = ({s3BookId, title} : CustomReaderProps) => {
    const [location, setLocation] = useState(0);

    const url = "https://silvanm-consultoria-bucket.s3.amazonaws.com/" + s3BookId

    return  <div className={'sticky top-4'} style={{ height: '80vh', width: '100%' }}>
        <Card style={{ height: '80vh', width: '100%' }}>
            <ReactReader
                url={url}
                title={title}
                location={location}
                locationChanged={(epubcfi: string) => console.log(epubcfi)}
                epubInitOptions={{
                    openAs: 'epub'
                }}
                epubOptions={{
                    allowPopups: true, // Adds `allow-popups` to sandbox-attribute
                    allowScriptedContent: true, // Adds `allow-scripts` to sandbox-attribute
                }}
            />
        </Card>
    </div>
};

export default CustomReader;
